import { createContext, useContext } from 'react';

export const MultiStepContext = createContext({
  currentStep: 0,
  next: () => {},
  handleChangeStep: () => {},
  reachedSteps: [],
  stepsValidity: [],
  handleSetReachedSteps: () => {},
  handleChangeStepsValidity: () => {},
});

export const useMultiStepContext = () => {
  const context = useContext(MultiStepContext);

  return context;
};

export const clearMuliStepContextLocalStorage = localStorageKey => {
  localStorage.removeItem(localStorageKey);
  localStorage.removeItem(`${localStorageKey}-REACHED_STEPS`);
  localStorage.removeItem(`${localStorageKey}-STEPS_VALIDITY`);
};
